import { useEffect, useRef, useMemo, useCallback } from 'react';
import mapboxgl from 'mapbox-gl';
import { createPortal } from 'react-dom';
import classnames from 'classnames';

import { HouseIcon } from '../icons/house';
import { shortPrice } from '../../helpers/short-price';

export function PropertyMarker({
  map,
  coords,
  bounds,
  isDetailed,
  items,

  fitBounds,
  highlight,
}) {
  let markerNode = useMemo(() => document.createElement(`div`), []);
  let markerRef = useRef(markerNode);

  useEffect(() => {
    let marker = new mapboxgl
      .Marker(markerRef.current)
      .setLngLat([coords[1], coords[0]])
      .addTo(map);

    return () => marker.remove();
  }, []);

  let onClick = useCallback(() => {
    if (isDetailed) highlight(items);
    else fitBounds(bounds);
  }, [isDetailed]);

  let iconClassName = useMemo(() => classnames(
    `map-search__marker`,
    items.length > 1 ? `map-search__marker_type_multiple` : `map-search__marker_type_single`,
  ), [items.length]);

  return createPortal(
    <div className={iconClassName} onClick={onClick}>
      <PropertyMarkerIcon items={items} />
    </div>,
    markerRef.current
  );
}

function PropertyMarkerIcon({
  items,
}) {
  if (items.length !== 1) return (
    <>
      <div className={`map-search__caption-icon`}><HouseIcon /></div>
      <div className={`map-search__caption-count`}>{items.length > 99 ? `+` : items.length}</div>
    </>
  );

  let property = items[0];

  if (!property.price) return `POA`;

  if (property.state === 'Sold') return `SOLD`;

  return (
    <>
      {shortPrice(property.price, property.currency)}{property.priceUnit === 'sqm' ? '/m²' : ''}
    </>
  );
}
